import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function validateOperationTypeInUsed(data) {
  return request({
    url: URL.mdm.basicData.validateOperationTypeInUsed,
    method: 'post',
    data
  })
}
